export default __webpack_public_path__ + "static/media/img_logo-veterans-1d62888b4b662af9142e3c385f423f32.4ec2844d.svg";